import styled from 'styled-components'

import COLORS from 'constants/colors'

import MEDIA from 'constants/media'


import { h3 } from 'components/base/Title/styles'


export const LocationGroup = styled.div`
  margin-bottom: 40px;
  ${h3} {
    margin-top: 0;
  }
`

export const JobAdvert = styled.span`
  display: block;
  margin-bottom: 3px;
  a:link,
  a:visited {
    color: ${COLORS.BLACK};
  }
`

export const JobList = styled.div`
  .BambooHR-ATS-board {
    .BambooHR-ATS-Department-Header {
      color: #000;
      font-family: futura-pt, sans-serif;
      font-size: 1.8rem;
    }
    h2 {
      font-size: 2rem;
      font-family: futura-pt, sans-serif;
      color: #000;
      font-weight: bold;
      border-bottom: none !important;
    }
    ul {
      font-size: 1.4rem;
      padding-left: 0;
      ul {
        border-bottom: none;
      }
      .BambooHR-ATS-Jobs-List .BambooHR-ATS-Location {
        float: none;
        display: block;
        padding-top: 0;
      }
    }
    a {
      font-size: 1.4rem;
      color: #000;
    }
  }
  ${MEDIA.medium`
    .BambooHR-ATS-board {
      ul {
        .BambooHR-ATS-Jobs-List .BambooHR-ATS-Location {
          float: right;
          padding-top: 9px;
        }
      }
    }
  `}
`
